import { render, staticRenderFns } from "./Realtimeprice.vue?vue&type=template&id=f20b1b84&scoped=true&"
import script from "./Realtimeprice.vue?vue&type=script&lang=js&"
export * from "./Realtimeprice.vue?vue&type=script&lang=js&"
import style0 from "./Realtimeprice.vue?vue&type=style&index=0&id=f20b1b84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20b1b84",
  null
  
)

export default component.exports